exports.getMatches = require('./get-matches').getMatches;